import { Component } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { faMemoCircleInfo }  from '@fortawesome/pro-solid-svg-icons';

import { AuthorizationViewModel } from "@app/shared/models";

@Component({
    templateUrl: 'authorization-digital-modal.component.html',
    styleUrls: ['authorization-digital-modal.component.scss']
})
export class AuthorizationDigitalModalComponent {
    deviceInfoIcon = faMemoCircleInfo;

    private _model: AuthorizationViewModel;
    get model(): AuthorizationViewModel {
        return this._model;
    }
    set model(value: AuthorizationViewModel) {
        this._model = value;
        if (this._model) {
            this.deviceInfoObject = JSON.parse(this._model.deviceInfo);
        }
    }
    deviceInfoObject: any | null = null;

    constructor(
        private modalRef: BsModalRef,
    ) {
    }

    onClose() {
        this.modalRef.hide();
    }
}
